import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Header from "../components/header/header"
import Hero from "../components/convenient-booking-page/hero"
import OnlineOrdering from "../components/convenient-booking-page/online-ordering"
import Reservation from "../components/convenient-booking-page/reservation"
import CallToAction from "../components/convenient-booking-page/call-to-action"
import StickyNav from "../components/sticky-nav"

const ConvenientBookingPage = () => (
    <Layout>
      <SEO title="Convenient Booking" />
      <Header />
      <Hero />
      <OnlineOrdering />
      <Reservation />
      <CallToAction />
      <StickyNav />
    </Layout>
  )
  
  export default ConvenientBookingPage